module.exports = __webpack_public_path__ + "img/org_img.5ada56ec.png";